import React from 'react';
import Wrapper from "./Wrapper";

const PageTitle = (props) => {
    return <h1 className="text-3xl text-black">{props.title}</h1>;
}

export default PageTitle;